import { render, staticRenderFns } from "./sales-report-page.vue?vue&type=template&id=44af9097&scoped=true&"
import script from "./sales-report-page.vue?vue&type=script&lang=ts&"
export * from "./sales-report-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44af9097",
  null
  
)

export default component.exports